<script setup>
import { inject, computed } from 'vue'
import { usePage } from '@inertiajs/vue3'

const __t = inject('__t')
const page = usePage()
const isRtl = computed(() => page.props.locale === 'ar')

const titlePart1 = __t('home_global_title_1')
const titlePart2 = __t('home_global_title_2')
const description = __t('home_global_description')
const visionTitle1 = __t('vision_title_1')
const visionTitle2 = __t('vision_title_2')
const visionExportText = __t('vision_export_text')
const visionTechText = __t('vision_tech_text')
</script>

<template>
    <section class="relative  overflow-hidden py-16" :dir="isRtl ? 'rtl' : 'ltr'">

        <div class=" mx-auto px-4 relative z-10">
            <!-- Centered Header -->
            <div class="text-center mb-12" :data-aos="'fade-up'">
                <h2
                    class="text-5xl md:text-5xl lg:text-6xl font-black text-[#2B4C7E] dark:text-blue-400 tracking-tight">
                    {{ titlePart1 }} {{ titlePart2 }}
                </h2>
            </div>

            <!-- Content Card -->
            <div class="relative max-w-6xl mx-auto mb-24" :data-aos="'fade-up'" data-aos-delay="200">
                <!-- Yellow Decorative Bar -->
                <div class="absolute -top-6 right-0 w-48 h-16 bg-[#F1C40F] z-20 hidden md:block"
                    :class="isRtl ? 'left-0 right-auto' : 'right-0'"></div>

                <!-- Main Blue Section -->
                <div
                    class="relative bg-gradient-to-br from-[#1E40AF] to-[#2563EB] rounded-sm overflow-hidden p-8 md:p-16 min-h-[400px] flex items-center shadow-2xl">
                    <!-- World Map Background Overlay -->
                    <div class="absolute inset-0 opacity-20 pointer-events-none mix-blend-overlay">
                        <img src="/assets/images/2 (1).png" alt="World Map Background"
                            class="w-full h-full object-cover grayscale invert" />
                    </div>

                    <!-- Text Content -->
                    <div class="relative z-10 w-full text-center md:text-right">
                        <p class="text-white text-lg md:text-2xl lg:text-2xl leading-[1.8] md:leading-[3] font-medium text-justify"
                            style="text-align-last: center; font-family: 'Inter', sans-serif;line-height: 2!important;">
                            {{ description }}
                        </p>
                    </div>
                </div>

                <!-- Floating Element (Optional, based on image markers) -->
                <div class="absolute bottom-4 left-4 flex gap-2">
                    <div class="w-3 h-3 bg-secondary rounded-full animate-ping"></div>
                </div>
            </div>




            <!-- Vision Section (New) -->
            <div class="relative ma x-w-8 xl mx-auto mt-24 overflow-hidden "
                :data-aos="'fade-up'">
         

                <div class="relative z-10 p-8 md:p-16">
                    <!-- Vision Title -->
                    <div class="flex flex-wrap items-end justify-center gap-2 mb-16 text-center">
                        <h3 class="text-4xl md:text-5xl font-black  leading-tight">
                            {{ visionTitle1 }}
                        </h3>
                        <div class="bg-[#F1C40F] px-4 py-1">
                            <h3 class="text-4xl md:text-5xl font-black  leading-tight">
                                {{ visionTitle2 }}
                            </h3>
                        </div>
                    </div>

                    <!-- Two Columns Content -->
                    <div class="grid grid-cols-1 md:grid-cols-2 gap-12 items-start">
                        <!-- Tech/Innovation Column -->
                        <div class="flex flex-col items-center md:items-start space-y-6 bg-primary p-12 rounded-xl h-full">
                            <div class="w-24 h-24 text-[#F1C40F]">
                                <!-- Technology/Innovation Icon -->
                            <img src="/assets/almatin/11 (4).png" alt="Innovation Icon" class="w-full h-full object-contain" />
                            </div>
                            <p class="text-white text-lg md:text-xl leading-relaxed text-justify"
                                :class="isRtl ? 'md:text-right' : 'md:text-left'" style="text-align-last: center;">
                                {{ visionTechText }}
                            </p>
                        </div>

                        <!-- Export/Global Column -->
                        <div class="flex flex-col items-center md:items-start space-y-6 bg-primary p-12 rounded-xl h-full">
                            <div class="w-24 h-24 text-[#F1C40F]">
                                <!-- Globe/Export Icon -->
                                <img src="/assets/almatin/11 (3).png" alt="Export Icon" class="w-full h-full object-contain" />
                            </div>
                            <p class="text-white text-lg md:text-xl leading-relaxed text-justify"
                                :class="isRtl ? 'md:text-right' : 'md:text-left'" style="text-align-last: center;">
                                {{ visionExportText }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<style scoped>
.tracking-tight {
    letter-spacing: -0.02em;
}

/* Ensure the background image fits well */
img {
    filter: brightness(0.8) contrast(1.2);
}

/* Custom animation for the content card */
[data-aos="fade-up"] {
    transition-timing-function: cubic-bezier(0.16, 1, 0.3, 1);
}

/* RTL Specific adjustments for the yellow bar */
[dir="rtl"] .absolute.-top-6.left-0 {
    left: 0;
    right: auto;
}
</style>
